import { transformMarkets } from '../../services/UserGroup.js';
import { APP_CONFIG, getHeaders } from '../constants/global-variables.js';

export async function getLiveMatch(requestId) {

    const url = `${APP_CONFIG.URL.apiBasePath}ajax/livegame/${requestId}`;

    try {
        const res = await axios.get(url, getHeaders());
        const dataTransformed = transformMarkets(res.data);
        const data = dataTransformed
        .map(groupMatch => {
          if (groupMatch[0].market_order === null) {
            groupMatch[0].market_order = 9999999;
          }
          return groupMatch;
        })
        .sort((a, b) => Number(a[0].market_order) - Number(b[0].market_order));
        return data;
    } catch (err) {
    }
}

export async function getLiveStreamLink(stream_id) {
    const url = `${APP_CONFIG.URL.apiBasePath}ajax/livestream/${stream_id}`;
    try {
        const res = await axios.get(url, getHeaders());
        return res.data;
    } catch (err) {
    }
}
